export const transition = `
  transition: .2s ease-out;
`;
